import React, { useState, useEffect } from 'react';
import Beforehand1 from './components/Beforehand1';
import Beforehand2 from './components/Beforehand2';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import Step5 from './components/Step5';
import Step6 from './components/Step6';
import Step7 from './components/Step7';
import Step8 from './components/Step8';
import Step9 from './components/Step9';
import Step10 from './components/Step10';
import Results from './components/Results';
import WatchVideo from './components/WatchVideo';
import ThankYou from './components/ThankYou';
import InitialScreen from './components/InitialScreen';
import LoadingOverlay from './components/LoadingOverlay';
import axios from 'axios';
import { calculateOSTA, formatOSTA } from './ostaCalculator/ostaCalculator';
import './App.css';
import { supabase } from './utils/supabaseClient';
import { getDecryptedCookie } from './utils/cryptoUtils';
import { v4 as uuidv4 } from 'uuid';
import { checkEnvironment } from './utils/environmentCheck';
import UnsupportedEnvironment from './components/UnsupportedEnvironment';
import { safeParseFloat, safeParseInt, parseFraxValue } from './utils/errorHandler';
import logoImage from './logo512.png'; // ロゴ画像をインポート

const OsteoporosisRiskCheck = () => {
  const [hospitalInfo, setHospitalInfo] = useState({ name: '', hospitalId: '', targetting: true });
  const [showInitialScreen, setShowInitialScreen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [globalStatusMessage, setGlobalStatusMessage] = useState('');

  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    weight: null,
    age: null,
    gender: null,
    height: null,
    previousFracture: null,
    parentHipFracture: null,
    currentSmoking: null,
    glucocorticoids: null,
    rheumatoidArthritis: null,
    secondaryOsteoporosis: null,
    alcohol: null,
    dentalCheck: null,
    dentalIssue: null,
    osteoporosisTreatment: null,
    boneDensityTest: null,
    isSubmitted: false
  });
  const [fraxResults, setFraxResults] = useState({ majorOsteoporotic: '', hipFracture: '' });
  // const [videoInteraction, setVideoInteraction] = useState({ videoId: '', playbackTime: 0, complete: false });
  const [disableNavigation, setDisableNavigation] = useState(false);
  const [fontSize, setFontSize] = useState(1);
  const [hasVisitedMainMenu, setHasVisitedMainMenu] = useState(false); 
  const [titleClass, setTitleClass] = useState('title-text-large');
  const [risk, setRisk] = useState(null);
  const [isDataSubmitted, setIsDataSubmitted] = useState(false);
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const [currentStep, setCurrentStep] = useState(0);
  const [hospital, setHospital] = useState(null);
  const [sessionStartTime, setSessionStartTime] = useState(null);
  const [isUnsupportedEnvironment, setIsUnsupportedEnvironment] = useState(false);

  // セッション初期化時のログ修正
  const initializeSession = () => {
    try {
      // 既存のセッションIDをチェック
      const existingId = sessionStorage.getItem('session_id');
      if (existingId) {
        console.log('既存のセッションを使用します');
        return existingId;
      }

      // 既存のセッションがない場合は新しいセッションを生成
      const sessionId = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      sessionStorage.setItem('session_id', sessionId);
      
      console.log('新しいセッションを作成しました');
      return sessionId;
    } catch (error) {
      console.error('セッション初期化エラー:', error);
      
      // エラーが発生した場合は一時的なセッションIDを生成
      const tempId = `temp-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
      try {
        sessionStorage.setItem('session_id', tempId);
      } catch (storageError) {
        console.error('一時的なセッションID保存中にエラーが発生:', storageError);
      }
      
      return tempId;
    }
  };

  // クッキーからログイン情報を取得
  useEffect(() => {
    const checkCookieLogin = async () => {
      setIsLoading(true);
      try {
        const hospitalInfoStr = getDecryptedCookie('hospital_info');
        
        if (hospitalInfoStr) {
          const hospitalData = JSON.parse(hospitalInfoStr);
          
          if (hospitalData && hospitalData.id && hospitalData.name) {
            console.log('クッキーからログイン情報を取得:', hospitalData);
            
            // Supabaseから最新のtargetting情報を取得
            try {
              const { data, error } = await supabase
                .from('hospitals')
                .select('targetting')
                .eq('id', hospitalData.id)
                .single();
                
              if (error) {
                console.error('Supabaseからtargetting情報取得エラー:', error);
                // エラーの場合はデフォルト値を使用
                setHospitalInfo({
                  name: hospitalData.name,
                  hospitalId: hospitalData.id,
                  targetting: true // エラー時のデフォルト値
                });
              } else {
                console.log('最新のtargetting情報取得:', data.targetting);
                setHospitalInfo({
                  name: hospitalData.name,
                  hospitalId: hospitalData.id,
                  targetting: data.targetting !== null ? data.targetting : true
                });
              }
            } catch (error) {
              console.error('Supabase接続エラー:', error);
              // エラーの場合はデフォルト値を使用
              setHospitalInfo({
                name: hospitalData.name,
                hospitalId: hospitalData.id,
                targetting: true // エラー時のデフォルト値
              });
            }
            
            setShowInitialScreen(false);
          } else {
            console.log('有効なログイン情報がクッキーにありません');
          }
        } else {
          console.log('ログイン情報がクッキーにありません');
        }
      } catch (error) {
        console.error('クッキーの読み込みエラー:', error);
      }
      setIsLoading(false);
    };
    
    checkCookieLogin();
  }, []);

  // ログイン成功時の処理
  const handleAccessGranted = (hospitalId, hospitalName, targetting = true) => {
    setHospitalInfo({
      name: hospitalName,
      hospitalId: hospitalId,
      targetting: targetting
    });
    setShowInitialScreen(false);
    
    // targetingがfalseの場合は直接Step1から始める
    if (!targetting) {
      setStep(2); // Step1のindex
    }
  };

  useEffect(() => {
    // クッキーからログイン情報取得後にtargettingの値に基づいて初期化処理を行う
    if (hospitalInfo.hospitalId && hospitalInfo.targetting === false) {
      console.log('targetting=falseを検出。セッションをリセットし、Step1を表示します。');
      
      // セッションをリセットして新規作成できるようにする
      sessionStorage.removeItem('session_id');
      sessionStorage.removeItem('session_completed');
      sessionStorage.removeItem('has_navigated_to_results');
      
      // 新しいセッションIDを生成して保存
      const newSessionId = uuidv4();
      sessionStorage.setItem('session_id', newSessionId);
      
      // Supabaseにセッションを登録
      const registerSession = async () => {
        try {
          const { data, error } = await supabase
            .from('sessions')
            .insert([{ 
              id: newSessionId,
              hospital_id: hospitalInfo.hospitalId
            }])
            .select('id');
            
          if (error) {
            console.error('セッション登録エラー:', error);
          } else {
            console.log('新しいセッションをSupabaseに登録しました:', newSessionId);
          }
        } catch (err) {
          console.error('セッション登録中に例外が発生:', err);
        }
      };
      
      registerSession();
      
      // targettingがfalseの場合は、osteoporosisTreatmentとboneDensityTestを明示的にnullに設定
      setFormData(prevData => ({
        ...prevData,
        osteoporosisTreatment: null,
        boneDensityTest: null
      }));
      
      // Step1にジャンプ
      setStep(2); // Step1のindex
    }
  }, [hospitalInfo]); // hospitalInfoが変更されたタイミングで実行

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    document.documentElement.style.setProperty('--dynamic-font-size', `${fontSize}`);
  }, [fontSize]);

  // グローバルに再送信関数を公開
  useEffect(() => {
    // 関数をグローバル変数として登録する代わりに、現在のformDataとfraxResultsを使用する関数を定義
    window.handleResubmit = () => {
      if (fraxResults.lastFormData) {
        // 内部でhandleResubmit関数と同様の処理を実装
        // 計算中のステータスを設定
        setIsProcessing(true);
        setGlobalStatusMessage('計算中です。しばらくお待ちください...');
        setFraxResults(prev => ({
          ...prev,
          calculating: true,
          statusMessage: '計算中です。しばらくお待ちください...'
        }));

        // 非同期関数を即時実行
        (async () => {
          try {
            const response = await axios.post('https://frax-server.vercel.app/frax', { 
              formData: fraxResults.lastFormData 
            });
            
            const { majorOsteoporotic, hipFracture, success, error, statusMessage } = response.data;

            // 計算が成功した場合
            if (success || (majorOsteoporotic !== 'エラー' && hipFracture !== 'エラー')) {
              setFraxResults({
                majorOsteoporotic,
                hipFracture,
                calculating: false,
                error: null,
                statusMessage: null
              });
            } else {
              // 計算が失敗した場合
              console.error('FRAX再計算エラー:', error || 'Unknown error');
              setFraxResults(prev => ({
                ...prev,
                majorOsteoporotic: 'エラー',
                hipFracture: 'エラー',
                calculating: false,
                error: error || 'Unknown error',
                statusMessage: statusMessage || '計算に失敗しました。「再送信」を押してください。'
              }));
              setGlobalStatusMessage(statusMessage || '計算に失敗しました。「再送信」を押してください。');
            }
            setIsProcessing(false);
          } catch (error) {
            console.error('Error during form resubmission', error);
            setFraxResults(prev => ({
              ...prev,
              calculating: false,
              error: error.message,
              statusMessage: '計算に失敗しました。「再送信」を押してください。'
            }));
            setGlobalStatusMessage('計算に失敗しました。「再送信」を押してください。');
            setIsProcessing(false);
          }
        })();
      }
    };
    
    return () => {
      // クリーンアップ
      delete window.handleResubmit;
    };
  }, [fraxResults.lastFormData]); // handleResubmitへの参照を削除し、必要な依存関係のみを残す

  useEffect(() => {
    const updateTitleClass = () => {
      if (window.innerWidth <= 767) {
        setTitleClass('title-text-small');
      } else {
        setTitleClass('title-text-large');
      }
    };

    updateTitleClass();
    window.addEventListener('resize', updateTitleClass);

    return () => {
      window.removeEventListener('resize', updateTitleClass);
    };
  }, []);

  const handleSubmit = async () => {
    try {
      // 計算中のステータスを設定
      setIsProcessing(true);
      setGlobalStatusMessage('計算中です。しばらくお待ちください...');
      setFraxResults({
        majorOsteoporotic: '',
        hipFracture: '',
        calculating: true,
        statusMessage: '計算中です。しばらくお待ちください...',
        lastFormData: null // 古いデータが残らないようにクリア
      });

      // 最大リトライ回数
      const MAX_RETRY_COUNT = 3;
      // リトライ回数カウンター
      let retryCount = 0;
      // 結果格納変数
      let fraxResult;

      // 最大リトライ回数まで試行する
      while (retryCount <= MAX_RETRY_COUNT) {
        try {
          // 現在の入力データを明示的にログに出力
          console.log(`FRAX計算用に送信するデータ (試行 ${retryCount + 1}/${MAX_RETRY_COUNT + 1}):`, { ...formData });

          // 現在のセッションIDをリクエストに含める
          const sessionId = sessionStorage.getItem('session_id');
          const requestData = { 
            formData, 
            metadata: { 
              sessionId,
              timestamp: new Date().toISOString(),
              requestId: `req-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
            } 
          };
          
          // リトライ中はステータスメッセージを更新
          if (retryCount > 0) {
            setGlobalStatusMessage(`難しい計算のようです。もう少しお待ちください...`);
          }
          
          const response = await axios.post('https://frax-server.vercel.app/frax', requestData, {
            timeout: 90000, // 90秒タイムアウト
            headers: {
              'Content-Type': 'application/json',
              'X-Request-ID': requestData.metadata.requestId,
              'Cache-Control': 'no-cache, no-store'
            }
          });

          // レスポンスが取得できた場合の処理
          const { majorOsteoporotic, hipFracture, success, error, statusMessage } = response.data;

          // レスポンスデータを明示的にログに出力
          console.log(`FRAX計算の結果 (試行 ${retryCount + 1}/${MAX_RETRY_COUNT + 1}):`, { 
            majorOsteoporotic, 
            hipFracture, 
            success, 
            formData: { ...formData }
          });

          // 計算が成功した場合
          if (success || (majorOsteoporotic !== 'エラー' && hipFracture !== 'エラー')) {
            fraxResult = {
              majorOsteoporotic,
              hipFracture,
              calculating: false,
              error: null,
              statusMessage: null,
              lastFormData: null // 成功時はクリア
            };
            
            // 成功したら結果を設定してループを抜ける
            break;
          } else {
            // 計算が失敗した場合
            console.error(`FRAX計算エラー (試行 ${retryCount + 1}/${MAX_RETRY_COUNT + 1}):`, error || 'Unknown error', {
              majorOsteoporotic, 
              hipFracture, 
              statusMessage
            });
            
            // 最大リトライ回数に達した場合
            if (retryCount === MAX_RETRY_COUNT) {
              fraxResult = {
                majorOsteoporotic: 'エラー',
                hipFracture: 'エラー',
                calculating: false,
                error: error || 'Unknown error',
                statusMessage: `計算に失敗しました。再送信を押してください。`,
                lastFormData: { ...formData } // 再送信用にフォームデータを保存
              };
            }
            
            // リトライをカウントアップ
            retryCount++;
          }
        } catch (axiosError) {
          console.error(`FRAX API通信エラー (試行 ${retryCount + 1}/${MAX_RETRY_COUNT + 1}):`, axiosError);
          
          // 最大リトライ回数に達した場合
          if (retryCount === MAX_RETRY_COUNT) {
            fraxResult = {
              majorOsteoporotic: 'エラー',
              hipFracture: 'エラー',
              calculating: false,
              error: axiosError.message || 'API通信エラー',
              statusMessage: `計算に失敗しました。再送信を押してください。`,
              lastFormData: { ...formData } // 再送信用にフォームデータを保存
            };
          }
          
          // リトライをカウントアップ
          retryCount++;
        }
        
        // リトライ前に少し待機
        if (retryCount <= MAX_RETRY_COUNT) {
          await new Promise(resolve => setTimeout(resolve, 1000)); // 1秒待機
        }
      }

      // 結果を設定
      setFraxResults(fraxResult);
      
      // 成功した場合のみResults画面に進む
      if (fraxResult.majorOsteoporotic !== 'エラー' && fraxResult.hipFracture !== 'エラー') {
        setStep(12); // 結果画面に進む
        setGlobalStatusMessage('');
      } else {
        // エラー時はStep10のまま
        setGlobalStatusMessage(fraxResult.statusMessage || '計算に失敗しました。再送信を押してください。');
        // エラーが続く場合は最終的にResults画面に遷移
        if (retryCount > MAX_RETRY_COUNT) {
          setStep(12); // エラー表示のためResult画面に進む
        }
      }
      
      setIsProcessing(false);
      return fraxResult;
    } catch (error) {
      // 予期しない例外
      console.error('予期しないエラー during form submission:', error, {
        formData: formData ? { ...formData, hasData: !!formData } : 'formDataが存在しません'
      });
      
      const errorResult = {
        majorOsteoporotic: 'エラー',
        hipFracture: 'エラー',
        calculating: false,
        error: error.message,
        statusMessage: '計算に失敗しました。再送信を押してください。',
        lastFormData: { ...formData } // 再送信用にフォームデータを保存
      };
      
      setFraxResults(errorResult);
      setStep(12); // エラー表示のためResult画面に進む
      setGlobalStatusMessage('計算に失敗しました。再送信を押してください。');
      setIsProcessing(false);
      
      return errorResult;
    }
  };

  const submitFormData = async (complete, osta, fraxMajor, fraxHip, calculatedRisk) => {
    // 重要なパラメータが欠けている場合は実行しない
    if (!calculatedRisk) {
      console.error('calculatedRiskが未定義のため、フォームデータ送信をスキップします');
      return;
    }
    
    // 既にフラグが立っていても、呼び出し元で再送信を明示的に求めている場合は送信を試みる

    const sessionId = sessionStorage.getItem('session_id');
    if (!sessionId) {
      console.error('セッションIDがありません、フォームデータを送信できません');
      return;
    }

    try {
      // 安全なデータ型変換 - 数値型の期待されるパラメータを確実に数値に変換
      const safeOsta = safeParseFloat(osta, 0);
      const safeFraxMajor = safeParseFloat(fraxMajor, 10);
      const safeFraxHip = safeParseFloat(fraxHip, 5);
      
      console.log('送信前のデータを準備しています');
      console.log('送信前のformData:', { 
        osteoporosisTreatment: formData.osteoporosisTreatment, 
        boneDensityTest: formData.boneDensityTest,
        targetting: hospitalInfo.targetting
      });
      
      // targettingがfalseの場合はosteoporosisTreatmentとboneDensityTestをnullに強制する
      let osteoporosisTreatmentValue = formData.osteoporosisTreatment;
      let boneDensityTestValue = formData.boneDensityTest;
      
      if (!hospitalInfo.targetting) {
        console.log('targetting=falseの医療機関のため、事前質問のデータをnullに強制します');
        osteoporosisTreatmentValue = null;
        boneDensityTestValue = null;
      } else {
        console.log('送信するデータの確認: osteoporosis_treatment=', osteoporosisTreatmentValue, 'bone_density_test=', boneDensityTestValue);
      }
      
      // 送信データのログ出力
      console.log('最終的な送信データ:', { 
        osteoporosis_treatment: osteoporosisTreatmentValue, 
        bone_density_test: boneDensityTestValue 
      });

      // 一時的なセッションかどうかをチェック
      const isTempSession = sessionId.startsWith('temp-');
      if (isTempSession) {
        console.log('一時的なセッションを検出。セッション登録をスキップしてデータのみ保存します。');
        
        try {
          // 完全なフォームデータをローカルストレージに保存
          const formSubmitData = {
            session_id: sessionId,
            complete,
            osteoporosis_treatment: osteoporosisTreatmentValue,
            bone_density_test: boneDensityTestValue,
            gender: formData.gender,
            age: formData.age,
            height: formData.height,
            weight: formData.weight,
            dental_check: formData.dentalCheck,
            dental_issue: formData.dentalIssue,
            previous_fracture: formData.previousFracture,
            parent_hip_fracture: formData.parentHipFracture,
            current_smoking: formData.currentSmoking,
            alcohol: formData.alcohol,
            glucocorticoids: formData.glucocorticoids,
            rheumatoid_arthritis: formData.rheumatoidArthritis,
            secondary_osteoporosis: formData.secondaryOsteoporosis,
            osta_value: safeOsta,
            frax_major: safeFraxMajor,
            frax_hip: safeFraxHip,
            risk: calculatedRisk,
            temp_data: true // 一時データフラグ
          };
          
          // ローカルストレージにデータを保存（データベース登録ができない場合のフォールバック）
          const storageKey = `temp_form_data_${Date.now()}`;
          localStorage.setItem(storageKey, JSON.stringify(formSubmitData));
          console.log('フォームデータをローカルストレージに保存しました');
          
          setFormData(prevData => ({ ...prevData, isSubmitted: true }));
          
          // 10秒後にバックグラウンドで再送信処理を試みる
          setTimeout(() => {
            attemptBackgroundSync();
          }, 10000);
          
          return;
        } catch (storageError) {
          console.error('ローカルストレージへの保存に失敗:', storageError);
        }
      }

      // 現在のセッションIDに関連するレコードがあるかを直接チェック
      const { data: existingRecords, error: fetchError } = await supabase
        .from('form_submit')
        .select('id')
        .eq('session_id', sessionId)
        .limit(1);

      if (fetchError) {
        console.error('既存レコードの確認中にエラーが発生しました:', fetchError);
        // エラーがあっても続行して登録を試みる
      } else if (existingRecords && existingRecords.length > 0) {
        console.log('既存のレコードが見つかりました。登録をスキップします');
        setFormData(prevData => ({ ...prevData, isSubmitted: true }));
        return;
      }

      // セッションIDがSupabaseに存在するか確認
      if (!isTempSession) {
        const { data: sessionExists, error: sessionCheckError } = await supabase
          .from('sessions')
          .select('id')
          .eq('id', sessionId)
          .limit(1);
        
        if (sessionCheckError) {
          console.error('セッション存在確認中にエラーが発生しました:', sessionCheckError);
          await saveToLocalStorageAndScheduleRetry(sessionId, safeOsta, safeFraxMajor, safeFraxHip, calculatedRisk);
          return;
        } else if (!sessionExists || sessionExists.length === 0) {
          console.log('セッションがデータベースに存在しません。セッションを登録します');
          
          try {
            // 存在しないセッションIDの場合は、新しくセッションを登録
            const { error: sessionInsertError } = await supabase
              .from('sessions')
              .insert([{ 
                id: sessionId,
                hospital_id: hospitalInfo.hospitalId
                // created_atは指定せず、デフォルト値now()を使用
              }]);
              
            if (sessionInsertError) {
              console.error('セッション登録エラー:', sessionInsertError);
              // セッション登録に失敗した場合はローカルストレージに保存し、後で再試行
              await saveToLocalStorageAndScheduleRetry(sessionId, safeOsta, safeFraxMajor, safeFraxHip, calculatedRisk);
              return;
            } else {
              console.log('セッションを登録しました');
            }
          } catch (sessionInsertErr) {
            console.error('セッション登録中に例外が発生:', sessionInsertErr);
            await saveToLocalStorageAndScheduleRetry(sessionId, safeOsta, safeFraxMajor, safeFraxHip, calculatedRisk);
            return;
          }
        }
      }

      // レコードを挿入 - セッションが確実に存在する場合のみ
      const formSubmitData = {
        session_id: sessionId,
        complete,
        osteoporosis_treatment: osteoporosisTreatmentValue,
        bone_density_test: boneDensityTestValue,
        gender: formData.gender,
        age: formData.age,
        height: formData.height,
        weight: formData.weight,
        dental_check: formData.dentalCheck,
        dental_issue: formData.dentalIssue,
        previous_fracture: formData.previousFracture,
        parent_hip_fracture: formData.parentHipFracture,
        current_smoking: formData.currentSmoking,
        alcohol: formData.alcohol,
        glucocorticoids: formData.glucocorticoids,
        rheumatoid_arthritis: formData.rheumatoidArthritis,
        secondary_osteoporosis: formData.secondaryOsteoporosis,
        osta_value: safeOsta,
        frax_major: safeFraxMajor,
        frax_hip: safeFraxHip,
        risk: calculatedRisk
      };

      const { data, error } = await supabase
        .from('form_submit')
        .insert([formSubmitData])
        .select();

      if (error) {
        console.error('フォームデータ送信エラー:', error);
        // 登録エラー時はローカルストレージに保存して後で再試行
        await saveToLocalStorageAndScheduleRetry(sessionId, safeOsta, safeFraxMajor, safeFraxHip, calculatedRisk, formSubmitData);
      } else {
        console.log('フォームデータが正常に送信されました');
        setFormData(prevData => ({ ...prevData, isSubmitted: true }));
      }
    } catch (error) {
      console.error('フォーム送信中に予期しないエラーが発生しました:', error);
      // 予期しないエラー時もローカルストレージに保存
      try {
        // エラー時のフォールバック値を設定
        const fallbackOsta = safeParseFloat(osta, 0);
        const fallbackFraxMajor = safeParseFloat(fraxMajor, 10); 
        const fallbackFraxHip = safeParseFloat(fraxHip, 5);
        
        await saveToLocalStorageAndScheduleRetry(sessionId, fallbackOsta, fallbackFraxMajor, fallbackFraxHip, calculatedRisk);
      } catch (storageErr) {
        console.error('ローカルストレージ保存中にエラー:', storageErr);
      }
    }
  };

  // データをローカルストレージに保存し、後で再試行するためのヘルパー関数
  const saveToLocalStorageAndScheduleRetry = async (sessionId, osta, fraxMajor, fraxHip, calculatedRisk, existingFormData = null) => {
    try {
      let formSubmitData = existingFormData;
      
      // targettingがfalseの場合はosteoporosisTreatmentとboneDensityTestをnullに強制する
      let osteoporosisTreatmentValue = formData.osteoporosisTreatment;
      let boneDensityTestValue = formData.boneDensityTest;
      
      if (!hospitalInfo.targetting) {
        console.log('一時保存: targetting=falseの医療機関のため、事前質問のデータをnullに強制します');
        osteoporosisTreatmentValue = null;
        boneDensityTestValue = null;
      }
      
      if (!formSubmitData) {
        formSubmitData = {
          session_id: sessionId,
          osteoporosis_treatment: osteoporosisTreatmentValue,
          bone_density_test: boneDensityTestValue,
          gender: formData.gender,
          age: formData.age,
          height: formData.height,
          weight: formData.weight,
          dental_check: formData.dentalCheck,
          dental_issue: formData.dentalIssue,
          previous_fracture: formData.previousFracture,
          parent_hip_fracture: formData.parentHipFracture,
          current_smoking: formData.currentSmoking,
          alcohol: formData.alcohol,
          glucocorticoids: formData.glucocorticoids,
          rheumatoid_arthritis: formData.rheumatoidArthritis,
          secondary_osteoporosis: formData.secondaryOsteoporosis,
          osta_value: osta,
          frax_major: fraxMajor,
          frax_hip: fraxHip,
          risk: calculatedRisk,
          timestamp: new Date().toISOString(),
          temp_data: true
        };
      } else if (!hospitalInfo.targetting) {
        // 既存のformSubmitDataがある場合も、targettingがfalseなら事前質問の値を強制的にnullに設定
        formSubmitData.osteoporosis_treatment = null;
        formSubmitData.bone_density_test = null;
      }
      
      // ローカルストレージにデータを保存
      const storageKey = `temp_form_data_${Date.now()}`;
      localStorage.setItem(storageKey, JSON.stringify(formSubmitData));
      console.log('データをローカルストレージに一時保存しました。後で再送信を試みます');
      
      // フォームが送信された状態にして、ユーザーには通常通り進めるようにする
      setFormData(prevData => ({ ...prevData, isSubmitted: true }));
      
      // 10秒後にバックグラウンドで再送信処理を試みる
      setTimeout(() => {
        attemptBackgroundSync();
      }, 10000);
    } catch (storageError) {
      console.error('ローカルストレージへの保存中にエラーが発生:', storageError);
    }
  };

  // バックグラウンド同期処理のログ修正
  const attemptBackgroundSync = async () => {
    console.log('バックグラウンド同期処理を開始します');
    
    try {
      // ローカルストレージから一時データを検索
      const tempDataKeys = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('temp_form_data_')) {
          tempDataKeys.push(key);
        }
      }
      
      if (tempDataKeys.length === 0) {
        console.log('同期対象の一時データはありません');
        return;
      }
      
      console.log(`${tempDataKeys.length}件の一時データをバックグラウンド処理します`);
      
      // 各一時データを処理
      for (const key of tempDataKeys) {
        try {
          const tempDataStr = localStorage.getItem(key);
          if (!tempDataStr) continue;
          
          const tempData = JSON.parse(tempDataStr);
          console.log('一時データ処理中');
          
          // 1. まずセッションテーブルの登録を確認/実行
          let sessionId = tempData.session_id;
          
          // セッションIDがないか無効な場合
          if (!sessionId) {
            console.log('バックグラウンド処理: 有効なセッションIDがありません');
            continue; // 次の一時データへ
          }
          
          // 2. フォームデータを構築（セッションIDを更新）
          // targettingがfalseの場合は強制的にnullに設定
          let osteoporosisTreatmentValue = tempData.osteoporosis_treatment;
          let boneDensityTestValue = tempData.bone_density_test;
          
          if (!hospitalInfo.targetting) {
            console.log('バックグラウンド処理: targetting=falseの医療機関のため、事前質問のデータをnullに設定します');
            osteoporosisTreatmentValue = null;
            boneDensityTestValue = null;
          }
          
          const formSubmitData = {
            session_id: sessionId,
            complete: tempData.complete || true,
            gender: tempData.gender || 'female',
            age: tempData.age || '65',
            height: tempData.height || '',
            weight: tempData.weight || '',
            dental_check: tempData.dental_check,
            dental_issue: tempData.dental_issue,
            previous_fracture: tempData.previous_fracture,
            parent_hip_fracture: tempData.parent_hip_fracture,
            current_smoking: tempData.current_smoking,
            alcohol: tempData.alcohol,
            glucocorticoids: tempData.glucocorticoids,
            rheumatoid_arthritis: tempData.rheumatoid_arthritis,
            secondary_osteoporosis: tempData.secondary_osteoporosis,
            osteoporosis_treatment: osteoporosisTreatmentValue,
            bone_density_test: boneDensityTestValue,
            osta_value: tempData.osta_value || 0,
            frax_major: tempData.frax_major || 10,
            frax_hip: tempData.frax_hip || 5,
            risk: tempData.risk || 'yellow'
          };
          
          // 3. form_submitテーブルに挿入
          const { error: formError } = await supabase
            .from('form_submit')
            .insert([formSubmitData]);
            
          if (formError) {
            console.error('バックグラウンド処理: form_submitエラー:', formError);
            continue; // 次の一時データへ
          }
          
          // 成功したら一時データを削除
          console.log('バックグラウンド処理: 完了、ローカルストレージから削除');
          localStorage.removeItem(key);
        } catch (dataError) {
          console.error('バックグラウンド処理: 一時データ処理中にエラー:', dataError);
        }
      }
      
      console.log('バックグラウンド同期処理が完了しました');
    } catch (error) {
      console.error('バックグラウンド同期処理中にエラーが発生:', error);
    }
  };

  // const submitVideoInteraction = async () => {
  //   const { videoId, playbackTime, complete } = videoInteraction;

  //   const { error } = await supabase
  //     .from('video_interactions')
  //     .insert([{
  //       session_id: sessionId,
  //       complete,
  //       video_id: videoId,
  //       playback_time: playbackTime
  //     }]);
  //   if (error) console.error('Supabase video interaction error:', error);
  // };

  // const handleVideoInteraction = (interaction) => {
  //   setVideoInteraction((prevInteraction) => ({
  //     ...prevInteraction,
  //     ...interaction
  //   }));
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setLastInteractionTime(Date.now());
  };

  const handleRiskUpdate = (calculatedRisk, osta, fraxMajor, fraxHip) => {
    console.log('handleRiskUpdate呼び出し:', { calculatedRisk, isSubmitted: formData.isSubmitted });
    
    // 常にriskの状態は更新（UIに反映するため）
    setRisk(calculatedRisk);
    
    // formDataがすでに送信済みの場合でも、再送信を試みる
    // これにより、以前のセッションでのエラーケースをカバー
    try {
      submitFormData(true, osta, fraxMajor, fraxHip, calculatedRisk);
      console.log('Supabaseへのデータ送信を試行');
    } catch (error) {
      console.error('handleRiskUpdateでのデータ送信エラー:', error);
    }
  };

  const handleBackClick = () => {
    // リセット処理をします
    resetFormData();
  };

  const renderStep = () => {
    switch (step) {
      case 0:
        // targettingがfalseの場合はStep1に自動遷移
        if (!hospitalInfo.targetting) {
          return <Step1 
            formData={formData} 
            handleInputChange={handleInputChange} 
            setStep={setStep} 
            hospitalId={hospitalInfo.hospitalId}
            needsSessionStart={true}
            onStepChange={handleStepChange}
          />;
        }
        return <Beforehand1 setStep={setStep} setFormData={setFormData} hospitalId={hospitalInfo.hospitalId} />;
      case 1:
        return <Beforehand2 setStep={setStep} setFormData={setFormData} />;
      case 2:
        return <Step1 
          formData={formData} 
          handleInputChange={handleInputChange} 
          setStep={setStep} 
          hospitalId={hospitalInfo.hospitalId} 
          needsSessionStart={true}
          onStepChange={handleStepChange}
        />;
      case 3:
        return <Step2 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 4:
        return <Step3 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 5:
        return <Step4 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 6:
        return <Step5 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 7:
        return <Step6 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 8:
        return <Step7 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 9:
        return <Step8 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 10:
        return <Step9 formData={formData} handleInputChange={handleInputChange} setStep={setStep} />;
      case 11:
        return <Step10 
          formData={formData} 
          handleInputChange={handleInputChange} 
          setStep={setStep} 
          handleSubmit={handleSubmit}
          setIsProcessing={setIsProcessing}
          setStatusMessage={setGlobalStatusMessage}
        />;
      case 12:
        const ageOsta = safeParseFloat(formData.age, 65);
        const weightOsta = safeParseFloat(formData.weight, 55);
        return (
          <Results
            calculateOSTA={() => calculateOSTA(weightOsta, ageOsta)}
            fraxResults={fraxResults}
            formData={formData}
            setStep={setStep}
            setFormData={setFormData}
            hasVisitedMainMenu={hasVisitedMainMenu}
            onRiskUpdate={handleRiskUpdate}
            hospitalInfo={hospitalInfo}
            handleResubmit={window.handleResubmit}
            onBack={handleBackClick}
            toggleVideo={() => setStep(13)}
            resetFormData={resetFormData}
            submitFormData={submitFormData}
          />
        );
      case 13:
        return <WatchVideo setStep={setStep} setFormData={setFormData} />;
      case 14:
        return <ThankYou setStep={setStep} formData={formData} setFormData={setFormData} setRisk={setRisk} hospitalInfo={hospitalInfo} />;
      default:
        return <Beforehand1 setStep={setStep} setFormData={setFormData} />;
    }
  };

  const resetFormData = () => {
    // リトライフラグをリセット
    sessionStorage.removeItem('has_navigated_to_results');
    
    // セッションIDも明示的にリセット（新規セッションを確実に始めるため）
    sessionStorage.removeItem('session_id');
    sessionStorage.removeItem('session_completed');
    
    // 新しいセッションIDを生成
    const newSessionId = uuidv4();
    sessionStorage.setItem('session_id', newSessionId);
    
    // Supabaseにセッションを登録
    if (hospitalInfo.hospitalId) {
      const registerSession = async () => {
        try {
          const { data, error } = await supabase
            .from('sessions')
            .insert([{ 
              id: newSessionId,
              hospital_id: hospitalInfo.hospitalId
            }])
            .select('id');
            
          if (error) {
            console.error('セッション登録エラー:', error);
          } else {
            console.log('新しいセッションをSupabaseに登録しました:', newSessionId);
          }
        } catch (err) {
          console.error('セッション登録中に例外が発生:', err);
        }
      };
      
      registerSession();
    }
    
    // フォームデータの初期値を設定（基本項目はすべてリセット）
    const initialFormData = {
      weight: null,
      age: null,
      gender: null,
      height: null,
      previousFracture: null,
      parentHipFracture: null,
      currentSmoking: null,
      glucocorticoids: null,
      rheumatoidArthritis: null,
      secondaryOsteoporosis: null,
      alcohol: null,
      dentalCheck: null,
      dentalIssue: null,
      osteoporosisTreatment: null,
      boneDensityTest: null,
      isSubmitted: false
    };
    
    // targettingがfalseの場合は、osteoporosisTreatmentとboneDensityTestを明示的にnullに設定
    if (!hospitalInfo.targetting) {
      console.log('resetFormData: targetting=falseの医療機関なので、事前質問の値を明示的にnullに設定します');
      initialFormData.osteoporosisTreatment = null;
      initialFormData.boneDensityTest = null;
    }
    
    setFormData(initialFormData);
    setRisk(null);
    
    // FRAXの結果もリセット
    setFraxResults({
      majorOsteoporotic: '',
      hipFracture: '',
      calculating: false,
      error: null,
      statusMessage: null,
      lastFormData: null
    });
    
    // targettingがfalseの場合はStep1に戻る
    if (!hospitalInfo.targetting) {
      setStep(2); // Step1のindex
    } else {
      setStep(0); // Beforehand1のindex
    }
  };

  useEffect(() => {
    const fetchHospital = async () => {
      try {
        const { data, error } = await supabase
          .from('hospitals')
          .select('*')
          .eq('id', hospitalInfo.hospitalId)
          .single();

        if (error) throw error;
        setHospital(data);

        // targettingがfalseの場合は、Beforehand1とBeforehand2をスキップ
        if (!data.targetting) {
          setCurrentStep(1); // Step1に直接遷移
          // セッション開始時間はStep1で「次の質問へ」ボタンが押されたときに設定する
          // setSessionStartTime(new Date()); の行は削除
        }
      } catch (error) {
        console.error('Error fetching hospital:', error);
      }
    };

    if (hospitalInfo.hospitalId) {
      fetchHospital();
    }
  }, [hospitalInfo.hospitalId]);

  const handleStepChange = (step) => {
    // Beforehand1またはStep1（targetting=false時）でセッション開始時間を設定
    if ((step === 1 && hospital?.targetting) || 
        (step === 3 && !hospital?.targetting)) { // Step1から次のステップへ移動時
      setSessionStartTime(new Date());
    }
    setCurrentStep(step);
  };

  // 環境チェック
  useEffect(() => {
    const environmentCheck = checkEnvironment();
    setIsUnsupportedEnvironment(environmentCheck.isUnsupported);
    
    // コンソールへの詳細情報出力（デバッグ用）
    if (process.env.NODE_ENV === 'development') {
      console.group('環境チェック（開発モード）');
      console.log('環境チェック結果:', environmentCheck);
      console.groupEnd();
    }
  }, []);

  // ステータスメッセージをグローバルに設定する関数
  const setStatusMessage = (message) => {
    setGlobalStatusMessage(message);
  };

  // アプリケーション起動時に未送信データをチェック・送信する処理を追加
  useEffect(() => {
    const checkPendingData = async () => {
      try {
        // ローカルストレージから未送信データを検索
        const pendingDataKeys = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && (key.startsWith('pending_results_data_') || key.startsWith('temp_thankyou_data_') || key.startsWith('temp_form_data_'))) {
            pendingDataKeys.push(key);
          }
        }
        
        if (pendingDataKeys.length === 0) {
          console.log('未送信データはありません');
          return;
        }
        
        console.log(`${pendingDataKeys.length}件の未送信データを処理します`);
        
        // 各未送信データを処理
        for (const key of pendingDataKeys) {
          const pendingDataStr = localStorage.getItem(key);
          if (!pendingDataStr) continue;
          
          try {
            const pendingData = JSON.parse(pendingDataStr);
            console.log('未送信データを処理:', key);
            
            // セッションIDの設定またはチェック
            let sessionId = pendingData.session_id;
            if (!sessionId || sessionId.startsWith('temp-')) {
              // セッションIDがないか一時的なIDの場合は新しいセッションを作成
              const originalTimestamp = pendingData.original_timestamp || pendingData.timestamp || new Date().toISOString();
              
              const { data: sessionData, error: sessionError } = await supabase
                .from('sessions')
                .insert([{ 
                  hospital_id: hospitalInfo.hospitalId,
                  created_at: originalTimestamp
                }])
                .select('id');
                
              if (sessionError || !sessionData || sessionData.length === 0) {
                console.error('未送信データ処理: セッション作成エラー:', sessionError);
                continue; // 次のデータへ
              }
              
              sessionId = sessionData[0].id;
              console.log('新しいセッションIDを作成:', sessionId);
            } else {
              // セッションIDが存在するか確認
              const { data: sessionExists, error: sessionCheckError } = await supabase
                .from('sessions')
                .select('id')
                .eq('id', sessionId)
                .limit(1);
              
              if (sessionCheckError || !sessionExists || sessionExists.length === 0) {
                // セッションIDが存在しない場合は新しく作成
                const originalTimestamp = pendingData.original_timestamp || pendingData.timestamp || new Date().toISOString();
                
                const { data: sessionData, error: sessionError } = await supabase
                  .from('sessions')
                  .insert([{ 
                    id: sessionId,
                    hospital_id: hospitalInfo.hospitalId,
                    created_at: originalTimestamp
                  }])
                  .select('id');
                  
                if (sessionError || !sessionData || sessionData.length === 0) {
                  console.error('未送信データ処理: セッション作成エラー:', sessionError);
                  continue; // 次のデータへ
                }
                
                console.log('セッションを再作成:', sessionId);
              }
            }
            
            // form_submitテーブルに挿入
            const formSubmitData = {
              session_id: sessionId,
              complete: pendingData.complete || true,
              risk: pendingData.risk || 'yellow',
              osta_value: pendingData.osta_value || 0,
              frax_major: pendingData.frax_major || 10,
              frax_hip: pendingData.frax_hip || 5,
              gender: pendingData.gender || 'female',
              age: pendingData.age || '65',
              height: pendingData.height || '',
              weight: pendingData.weight || '',
              dental_check: pendingData.dental_check,
              dental_issue: pendingData.dental_issue,
              previous_fracture: pendingData.previous_fracture,
              parent_hip_fracture: pendingData.parent_hip_fracture,
              current_smoking: pendingData.current_smoking,
              alcohol: pendingData.alcohol,
              glucocorticoids: pendingData.glucocorticoids,
              rheumatoid_arthritis: pendingData.rheumatoid_arthritis,
              secondary_osteoporosis: pendingData.secondary_osteoporosis,
              osteoporosis_treatment: pendingData.osteoporosis_treatment,
              bone_density_test: pendingData.bone_density_test
            };
            
            // すでに同じセッションIDのデータが存在するか確認
            const { data: existingData, error: checkError } = await supabase
              .from('form_submit')
              .select('id')
              .eq('session_id', sessionId)
              .limit(1);
              
            if (!checkError && existingData && existingData.length > 0) {
              console.log('このセッションIDのデータは既に存在するため送信をスキップします:', sessionId);
              localStorage.removeItem(key);
              continue; // 次のデータへ
            }
            
            // データ送信
            const { error: submitError } = await supabase
              .from('form_submit')
              .insert([formSubmitData]);
              
            if (submitError) {
              console.error('未送信データの送信エラー:', submitError);
              continue; // 次のデータへ（失敗したデータは残す）
            }
            
            // 成功したらローカルストレージから削除
            localStorage.removeItem(key);
            console.log('未送信データの送信成功、ローカルストレージから削除:', key);
          } catch (dataError) {
            console.error('未送信データの処理エラー:', dataError);
          }
        }
      } catch (error) {
        console.error('未送信データチェック中のエラー:', error);
      }
    };
    
    // アプリケーション起動時に未送信データをチェック
    checkPendingData();
  }, [hospitalInfo.hospitalId]);

  // セッションID確認関連ログの修正
  useEffect(() => {
    if (currentStep === 0) {
      console.log('初期ステップ: セッション確認中');
      
      // セッションIDを確認
      const sessionId = sessionStorage.getItem('session_id');
      if (!sessionId) {
        console.log('セッションIDが見つかりません。新しく初期化します');
        const newSessionId = initializeSession();
        
        // Supabaseにセッションを登録（病院IDがある場合のみ）
        if (hospitalInfo.hospitalId) {
          const registerSession = async () => {
            try {
              const { data, error } = await supabase
                .from('sessions')
                .insert([{ 
                  id: newSessionId,
                  hospital_id: hospitalInfo.hospitalId
                }])
                .select('id');
                
              if (error) {
                console.error('セッション登録エラー:', error);
              } else {
                console.log('新しいセッションをSupabaseに登録しました:', newSessionId);
              }
            } catch (err) {
              console.error('セッション登録中に例外が発生:', err);
            }
          };
          
          registerSession();
        }
      } else {
        console.log('既存のセッションを使用します');
      }
    }
  }, [currentStep, hospitalInfo.hospitalId]);

  // 病院情報取得時のログ修正
  useEffect(() => {
    // 病院IDが指定されている場合、関連情報を取得
    const fetchHospitalInfo = async () => {
      // URLからパラメータを取得
      const urlParams = new URLSearchParams(window.location.search);
      const hospitalId = urlParams.get('hospital');
      
      if (!hospitalId) {
        console.log('病院IDの指定がありません');
        setHospitalInfo({
          hospitalId: null,
          hospitalName: 'デフォルト',
          loading: false
        });
        return;
      }
      
      try {
        console.log('病院情報を取得中');
        
        // Supabaseから病院情報を取得
        const { data, error } = await supabase
          .from('hospitals')
          .select('id, name')
          .eq('id', hospitalId)
          .limit(1);
          
        if (error) {
          console.error('病院情報取得エラー:', error);
          setHospitalInfo({
            hospitalId,
            hospitalName: '不明な医療機関',
            loading: false
          });
          return;
        }
        
        if (data && data.length > 0) {
          console.log('病院情報を取得しました');
          setHospitalInfo({
            hospitalId: data[0].id,
            hospitalName: data[0].name,
            loading: false
          });
        } else {
          console.log('指定された病院IDに該当する情報がありません');
          setHospitalInfo({
            hospitalId,
            hospitalName: '不明な医療機関',
            loading: false
          });
        }
      } catch (err) {
        console.error('病院情報取得中に予期しないエラーが発生:', err);
        setHospitalInfo({
          hospitalId,
          hospitalName: 'エラー',
          loading: false
        });
      }
    };
    
    fetchHospitalInfo();
  }, []);

  // ロード中の表示
  if (isLoading) {
    return <LoadingOverlay isVisible={true} />;
  }

  // 非対応環境の場合は専用画面を表示（InitialScreenより先にチェック）
  if (isUnsupportedEnvironment) {
    return <UnsupportedEnvironment setStep={setCurrentStep} hospitalInfo={hospitalInfo} />;
  }

  // 初期画面表示
  if (showInitialScreen) {
    return <InitialScreen onAccessGranted={handleAccessGranted} />;
  }

  return (
    <div className="App">
      <LoadingOverlay isVisible={isLoading || isProcessing} statusMessage={globalStatusMessage} />
      <div className="container mx-auto" style={{ paddingTop: '30px' }}>
        <div className="title-container text-center cursor-pointer flex items-center justify-center mb-6"
          onClick={resetFormData}
        >
          <img 
            src={logoImage}
            alt="Logo" 
            className="logo cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              if (!disableNavigation) {
                window.open('https://curelity.co.jp/', '_blank');
              }
            }}
          />
          <h2 className="common-title title-text">
            {hospitalInfo.name === '天白橋内科内視鏡クリニック' ? (
              <>天白橋内科内視鏡<br />クリニック<br />ほねなび</>
            ) : (
              <>{hospitalInfo.name}<br />ほねなび</>
            )}
          </h2>
        </div>
        <div className="zoom-controls text-center my-4">
          <span className="text-sm mr-2">文字サイズ：</span>
          <span className="text-xs mr-2">小</span>
          <input 
            type="range" 
            id="zoomSlider" 
            min="0.8" 
            max="5" 
            step="0.02" 
            value={fontSize} 
            onInput={(e) => setFontSize(e.target.value)} 
            className="mr-2"
          />
          <span className="text-sm mr-2">大</span>
          <button onClick={() => setFontSize(1)} className="bg-gray-500 text-white p-1 rounded hover:bg-gray-600 text-sm ml-2">
            リセット
          </button>
        </div>
        {renderStep()}
      </div>
    </div>
  );
};

export default OsteoporosisRiskCheck;